import { inviteUser } from "./states";

export const services = {
  inviteUser,
};
